<h2 mat-dialog-title>{{titulo}}</h2>
<mat-dialog-content>
  <div class="progress-container">
    <mat-progress-bar mode="determinate" [value]="progresado"></mat-progress-bar>
    <span class="progress-text">{{ progresado | number: '1.0-0' }}%</span>
  </div>

  <ng-container *ngIf="recargados?.length">
    <p class="title">✅ Pedido realizado</p>
    <div class="tank-list">
      <p *ngFor="let est of recargados" class="success">{{ est.nombre }} Tanque Nº {{ est.numTank }}</p>
    </div>
  </ng-container>

  <ng-container *ngIf="pedidosHechos?.length">
    <p class="title">⚠️ Pedido realizado anteriormente</p>
    <div class="tank-list">
      <p *ngFor="let est of pedidosHechos" class="warning">{{ est.nombre }} Tanque Nº {{ est.numTank }}</p>
    </div>
  </ng-container>

  <ng-container *ngIf="errores?.length">
    <p class="title">❌ Error en la solicitud del pedido</p>
    <div class="tank-list">
      <p *ngFor="let est of errores" class="error">{{ est.nombre }} Tanque Nº {{ est.numTank }}</p>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="dialogRefRealizarRecarga.close()">Cerrar</button>
</mat-dialog-actions>
